<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button grey" :to="{ path: '/relays/' }"><i class="fa fa-angle-left"></i></router-link>
            <button :disabled="is_save" class="fl-button" type="button" v-on:click="save"><i class="fa fa-save"></i></button>
          </div>
          <h1>Relé</h1>
          <div class="row">
            <div class="col-xs-6">
              <inputbox id="name" label="Megnevezés" v-bind:errors="errors" name="name" v-model="form.name"></inputbox>
              <comboboxV2 id="controller_id" label="Kontroller" v-bind:errors="errors" name="controller_id" v-model="form.controller_id" :options="controllers"></comboboxV2>
              <inputbox regexp_filter="[0-9]+" id="address" label="Relé címe" v-bind:errors="errors" name="address" v-model="form.address"></inputbox>
              <comboboxV2 id="operating_mode" label="Működési mód" v-bind:errors="errors" name="operating_mode" v-model="form.operating_mode" :options="operating_modes"></comboboxV2>
              <textareabox id="comment" label="Megjegyzés" v-bind:errors="errors" name="comment" v-model="form.comment"></textareabox>
              <!--<div class="row">
                <div class="col-xs-6">
                  <comboboxV2 :change="changeDeviceType" id="device_types" label="Eszköz típus" name="device_types" v-model="device_type_id" :options="device_types"></comboboxV2>
                  <div style="display: flex; justify-content: space-between; align-items: center;">
                    <comboboxV2 style="width: 90%" id="device_id" label="Eszköz" name="device_id" v-model="device_id" :options="devices"></comboboxV2>
                    <button v-on:click="deviceSelect" v-show="device_id != 0" type="button" class="button small"><i class="fa fa-chevron-right"></i></button>
                  </div>
                </div>
                <div class="col-xs-6">
                  Eszközök
                  <div v-if="form.devices.length > 0" class="selected-items-list" style="margin-top: 10px;">
                    <div class="item" v-for="device in form.devices">
                      <button v-on:click="deviceDelete(device.value)" type="button" class="button small"><i class="fa fa-trash"></i></button>
                      {{ device.label }}
                    </div>
                  </div>
                  <div v-if="form.devices.length == 0" class="normal-text" style="margin-top: 10px;">
                    Nem található csatolt eszköz.
                  </div>
                </div>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <HTMLFooter></HTMLFooter>
    <ProgressInfo :show="is_save"/>
  </div>
</template>
<script>
export default {
  components: {
  },

  data: function() {
    return {
      form: {
        element_id: 0,
        controller_id: 0,
        name: '',
        address: '',
        comment: '',
        operating_mode: 0,
        devices: []
      },

      operating_modes: [
        {
          label: 'Normál',
          value: 0
        },
        {
          label: 'Fordított',
          value: 1
        }
      ],
      device_types: [
        {
          label: '- válassz -',
          value: 0
        },
        {
          label: 'Ajtó',
          value: 1
        },
        {
          label: 'Sorompó',
          value: 2
        },
        {
          label: 'Forgóvilla',
          value: 3
        }
      ],
      device_type_id: 0,
      devices: [{
        label: '- válassz -',
        value: 0
      }],
      device_id: 0,
      controllers: [{
        label: '- válassz -',
        value: 0
      }],
      errors: [],
      is_save: false
    }
  },

  mounted: function() {
    var _this = this;

    this.$root.checkRootUserHasSet(function() {
      _this.$root.ajax('relay/edit/' + _this.$root.user.apikey + '/' + (_this.$route.query.relayID != undefined ? _this.$route.query.relayID : 0), {
        success: function(response) {
          _this.form = response.relay;
          _this.getControllers();
        }
      });
    });
  },

  methods: {
    deviceDelete: function(value) {
      var tmp = [];
      this.form.devices.map(function(device) {
        if (device.value != value)
          tmp.push(device);
      });
      this.form.devices = tmp;

      // Combó frissítés törlés után
      this.changeDeviceType();
    },

    deviceSelect: function() {
      var _this = this;

      this.devices.map(function(device) {
        if (device.value == _this.device_id) {
          _this.form.devices.push(device);
        }
      });

      // Combó frissítés hozzáadás után
      this.changeDeviceType();
    },

    changeDeviceType: function() {
      var _this = this;

      this.devices = [{
        label: '- válassz -',
        value: 0
      }];

      this.device_id = 0;

      if (this.device_type_id == 0)
        return false;

      _this.$root.ajax('devices_by_type/' + _this.$root.user.apikey + '/' + this.device_type_id, {
        success: function(response) {
          response.devices.map(function(device) {
            var to_array = true;

            _this.form.devices.map(function(fdevice) {
              if (device.element_id == fdevice.value)
                to_array = false;
            });

            if (to_array) {
              _this.devices.push({
                label: device.name,
                value: device.element_id
              })
            }
          });
        }
      });
    },

    getControllers: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('controllers/' + _this.$root.user.apikey + '/1', {
          method: 'POST',
          data: {},
          success: function(response) {
            response.controllers.map(function(controller) {
              _this.controllers.push({
                label: controller.name,
                value: controller.element_id
              })
            });
          }
        });
      });
    },

    save: function (event) {
      var _this = this;
      var form = JSON.parse(JSON.stringify(_this.form));
      this.is_save = true;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('relay/save/' + _this.$root.user.apikey, {
          method: 'POST',
          data: form,
          waitForSaveInfo: true,
          success: function(response) {
            _this.is_save = false;

            if (response.errors.length > 0) {
              _this.errors = response.errors;
            } else {
              _this.$router.push({path: '/relays'});
            }
          }
        });
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// relay.vue?c902b3de